document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-bkc-show]');
  if (!button) return;
  const gallery = button.closest('[data-bkc-gallery]');
  if (!gallery) return;
  gallery.querySelectorAll('[data-bkc-face]').forEach(image => {
    image.hidden = image.dataset.bkcFace !== button.dataset.bkcShow;
  });
  gallery.querySelectorAll('[data-bkc-show]').forEach(control => {
    control.setAttribute('aria-pressed', String(control === button));
  });
});
